<template>
    <div class="mx-auto container container--fluid">
        <!-- <div>
            <Breadcrumbs :extraBreadcrumb="extraBreadcrumbItems" :class="breadcrumbClass" />

        </div> -->
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>
        <v-card class="box">
            <v-data-table :headers="headers" :items="occupation_list" class="elevation-1 mytable" dense
                :search="search">
                <template v-slot:top>
                    <v-toolbar dense class="toolbar" flat color="white">
                        <v-toolbar-title>Occupation</v-toolbar-title>
                        <v-divider class="mx-4" inset vertical></v-divider>
                        <v-spacer></v-spacer>
                    </v-toolbar>

                    <span style="width: 20px;"> </span>
                    <v-row justify="center" dense>
                        <v-col sm="3" md="8" cols="12"> </v-col>
                        <v-col sm="6" md="6" cols="12">
                            <v-text-field v-model="search" append-icon="search" label="Search" single-line
                                hide-details></v-text-field>
                        </v-col>
                        <span style="width: 20px;"> </span>
                        <v-dialog v-model="dialog" max-width="500px">
                            <template v-slot:activator="{ on }">
                                <v-btn class="mb-2 button" v-on="on" small>Add Occupation</v-btn>
                            </template>
                            <v-card>
                                <v-form v-model="valid">
                                    <v-card-title class="toolbar">
                                        <span class="headline">{{ formTitle }}</span>
                                    </v-card-title>

                                    <v-card-text>
                                        <v-container>
                                            <v-row>
                                                <!-- <v-col cols="12" sm="12" md="12">
                    <v-select
                      :items="occupation_super_master_list"
                      v-model="editedItem.occupation"
                      item-text="occupation_super_master_list_id"
                      item-value="id"
                      persistent-hint
                      :disabled="editedIndex != -1"
                      :hint="editedIndex==-1?'For example :: Farmer, Teacher ':'noneditable'"
                      :filled="editedIndex==-1?false:true"
                      label="Occupation"
                      :error="errorMsg.occupation?true:false"
                      :error-messages="errorMsg.occupation?'Required':''"
                    ></v-select>
                  </v-col> -->
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex == -1">
                                                    <v-autocomplete :items="occupation_super_master_list"
                                                        v-model="addedItem.occupation_super_master_list"
                                                        label="Select Occupation"
                                                        :rules="[(v) => !!v || 'required']"></v-autocomplete>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="editedIndex != -1">
                                                    <v-text-field v-model.trim="editedItem.occupation" persistent-hint
                                                        :disabled="editedIndex != -1" :hint="
                              editedIndex == -1
                                ? 'For example ::Farmer, Teacher '
                                : 'noneditable'
                            " label="Occupation" :rules="[(v) => !!v || 'required']"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col>
                                                    <v-text-field label="Occupation In Unicode" v-model="editedItem.unicode_occupation"></v-text-field>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col cols="12" sm="6" md="4" v-if="editedIndex != -1">
                                                    <v-checkbox dense v-model="editedItem.isactive" color="success"
                                                        label="Active"></v-checkbox>
                                                </v-col>
                                            </v-row>
                                            <v-row>
                                                <v-col v-if="editedIndex == -1">
                                                    <v-checkbox dense v-model="newcheckbox" color="success"
                                                        label="Occupation not present in above list? Add new here..."></v-checkbox>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12"
                                                    v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field v-model.trim="newoccupation" persistent-hint
                                                        hint="For example :: Account Collector, Library Technician, Mail Clerk, Mechanical Engineer"
                                                        label="New Occupation" ref="newoccupation"></v-text-field>
                                                </v-col>
                                            </v-row>    
                                                <v-row>
                                                    <v-col v-if="editedIndex == -1 && newcheckbox">
                                                    <v-text-field label="New Occupation In Unicode" v-model="unicode_new_occupation"></v-text-field>
                                                </v-col>
                                                <v-col cols="12" sm="12" md="12" v-if="newcheckbox">
                                                    <v-btn class="mb-2 button" color="primary" small
                                                        @click="saveNewOccupation">Save New Occupation</v-btn>
                                                </v-col>
                                            </v-row>
                                        </v-container>
                                    </v-card-text>

                                    <v-card-actions>
                                        <v-spacer></v-spacer>
                                        <v-btn class="mb-2 button" text @click="close">Cancel</v-btn>
                                        <v-btn class="mb-2 button" @click="save" :disabled="!valid">Save</v-btn>
                                    </v-card-actions>
                                </v-form>
                            </v-card>
                        </v-dialog>
                    </v-row>
                </template>

                <template v-slot:item.isactive="{ item }">
                    <span v-if="item.isactive">
                        <v-icon class="mr-2 v-icon-size" color="success">mdi-check-circle-outline</v-icon>
                    </span>
                    <span v-else>
                        <v-icon class="mr-2 v-icon-size" color="error">mdi-close-circle-outline</v-icon>
                    </span>
                </template>

                <template v-slot:item.action="{ item }">
                    <div>
                        <v-avatar style="" size="25" class="edit-avatar">
                            <v-icon class="edit-v-icon mr-2" @click="editItem(item)">edit</v-icon>
                        </v-avatar>
                    </div>
                    <!-- <v-icon
        small
        @click="deleteItem(item)"
      >
        delete
      </v-icon> -->
                </template>
                <!-- <template v-slot:no-data>
      <v-btn color="primary" @click="initialize">Reset</v-btn>
    </template> -->
            </v-data-table>
            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>
    </div>
</template>

<script>
import axios from "axios";
import Breadcrumbs from "@/components/shared/Breadcrumbs.vue"; // Adjust the path as needed
export default {
    components: {
        Breadcrumbs,
    },
        data: () => ({
            valid: false,
            occupation_super_master_list: "",
            overlay: false,
            occupation: ["Farmer", "Doctor", "advocate"],
            errorMsg: {
                occupation: false,
            },
            snackbar_msg: "",
            color: "",
            snackbar: false,
            // extraBreadcrumbItems: [
            //     { text: "Occupation Master", disabled: true, href: "" },

            // ],


            // breadcrumbClass: "breadcrumb-style2",
            search: "",
            dialog: false,
            search: "",
            search: "",
            newoccupation: "",
            unicode_new_occupation:"",
            newcheckbox: false,
            dialog: false,
            headers: [
                {
                    text: "Occupation",
                    align: "left",
                    sortable: false,
                    value: "occupation",
                },
                {
                    text: "Occupation In Unicode",
                    align: "left",
                    sortable: false,
                    value: "unicode_occupation",
                },
                {
                    text: "Active",
                    align: "left",
                    sortable: true,
                    value: "isactive",
                },
                { text: "Actions", value: "action", sortable: false },
            ],
            occupation_list: [],
            editedIndex: -1,
            addedItem: {
                occupation_super_master_list: "",
            },
            editedItem: {
                id: "",
                occupation: "",
                unicode_occupation:"",
                isactive: true,
            },
            defaultItem: {
                id: "",
                occupation: "",
                unicode_occupation:"",
                isactive: true,
            },
        }),

        computed: {
            formTitle() {
                return this.editedIndex === -1 ? "New Occupation" : "Edit Occupation";
            },
        },

        watch: {
            dialog(val) {
                val || this.close();
            },
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },

        // created () {
        //   this.initialize()
        // },
        mounted() {
            this.onLoad();
        },
        methods: {
            //   initialize () {

            //   },
                    hasWhiteSpace(s) {
                var status = false;
                var reWhiteSpace = new RegExp(/^\s+$/);

                // Check for white space
                if (reWhiteSpace.test(s)) {
                    // alert("Please Check Your Fields For Spaces");
                    return true;
                }
                return false;
            },
            saveNewOccupation() {
                if (this.newoccupation == null || this.newoccupation == "") {
                    if(this.hasWhiteSpace(this.newoccupation))
                    this.showSnackbar("#b71c1c", "Please add occupation!");
                    this.$refs["newoccupation"].focus();
                    return;
                }
                let data = {
                    newoccupation: this.newoccupation,
                    unicode_new_occupation : this.unicode_new_occupation
                };
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/addNewOccupation", data)
                    .then((res) => {
                        (this.newoccupation = ""), (this.newcheckbox = false), (this.overlay = false);
                        if (res.data.status.code == "SUCCESS") {
                            this.showSnackbar("#4caf50", "Category Added Successfully!!!"); // show snackbar on success
                            this.onLoad();
                        } else if (res.data.status.code == "NA") {
                            this.showSnackbar("#b71c1c", "Category Already Present!"); // show snackbar on error
                        }
                    })
                    .catch((error) => {
                        this.overlay = false;
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.overlay = false;
                    });
                this.close();
            },

            onLoad() {
                this.overlay = true;
                axios
                    .post("/AdmissionMaster/occupation")
                    .then((res) => {
                        if (res.data.msg == "200") {
                            //window.alert(res.data.msg)

                            if ((this.load = true)) {
                                this.overlay = false;
                                this.occupation_list = res.data.occupation_list;
                                this.occupation_super_master_list = res.data.occupation_super_master_list;
                            }
                        } else {
                            window.console.log(res.data.msg);
                        }
                    })
                    .catch((error) => {
                        this.showSnackbar("#b71c1c", "Something went wrong..."); // show snackbar
                        window.console.log(error);
                    })
                    .finally(() => {
                        "use strict";
                        var overlay = false;
                    });
            },
            editItem(item) {
                this.editedIndex = this.occupation_list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true;
            },
            showSnackbar(clr, msg) {
                this.snackbar = true;
                this.color = clr;
                this.snackbar_msg = msg;
            },
            // deleteItem (item) {
            //   const index = this.occupation_list.indexOf(item)
            //   confirm('Are you sure you want to delete this item?') && this.occupation_list.splice(index, 1)
            // },

            close() {
                this.dialog = false;
                setTimeout(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1;
                }, 300);
                this.newcheckbox = false;
                this.newoccupation = "";
                this.unicode_new_occupation="";
            },

            save() {
                if (this.editedIndex > -1) {
                    if (this.isValidated()) {
                        axios
                            .post("/AdmissionMaster/editOccupation", this.editedItem)
                            .then((res) => {
                                if (res.data.msg == "200") {
                                    //window.alert(res.data.msg)
                                    this.onLoad();
                                    Object.assign(this.occupation_list[this.editedIndex], this.editedItem);
                                }
                                this.showSnackbar("#4caf50", "Occupation Updated Successfully..."); // show snackbar on success
                            })
                            .catch((error) => {
                                window.console.log(error);
                            });
                        this.close();
                    }
                } else {
                    axios
                        .post("/AdmissionMaster/saveOccupation", this.addedItem)
                        .then((res) => {
                            if (res.data.status.code == "SUCCESS") {
                                //window.alert(res.data.status.code)
                                this.occupation_list.push(this.addedItem);
                                this.showSnackbar("#4caf50", "Occupation Added Successfully!!!"); // show snackbar on success
                                this.onLoad();
                            } else if (res.data.status.code == "NA") {
                                //window.alert(res.data.status.code)
                                this.showSnackbar("#b71c1c", "Occupation Already Present!!!"); // show snackbar on error
                            }
                        })
                        .catch((error) => {
                            window.console.log(error);
                        });
                    this.close();
                }
            }, //save()
            isValidated() {
                // alert('I am in isValidated()'+this.editedItem.name +"||" +this.editedItem.usertype.id +"||"+this.editedItem.roletype.id)
                if (this.editedItem.occupation) {
                    return true;
                } else {
                    if (!this.editedItem.occupation) {
                        this.errorMsg.occupation = true;
                    }

                    return false;
                }
            }, // .....end of isValidated()
        },
    };
</script>
<style scoped>
    .v-text-field {
        padding-top: 0px;
        margin-top: 0px;
    }
    .v-icon-size {
        font-size: 20px;
    }
    .edit-avatar {
        transition: 0.3s;
        border: 1px solid #b0bec5;
    }
    .edit-avatar:hover {
        background-color: #b0bec5;
    }
    .edit-v-icon {
        padding-left: 6px;
        font-size: 15px;
    }
    .edit-v-icon:hover {
        color: white;
    }
</style>
